// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-card {
  --border-style: none;
  --inner-border-width: 0px;
  zoom: 0.75;
}

cdk-virtual-scroll-viewport {
  height: 100%;
  width: 100%;
}

ion-select::part(icon) {
  display: none !important;
}

ion-checkbox {
  --size: 32px;
}

ion-content {
  --ion-background-color: white !important; /* Change la couleur de fond */
}

.checkbox-wrapper {
  justify-content: center !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/sessions/list-session-bis/list-session-bis.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,yBAAA;EACA,UAAA;AACJ;;AAEE;EACE,YAAA;EACA,WAAA;AACJ;;AAEE;EACE,wBAAA;AACJ;;AAEG;EACC,YAAA;AACJ;;AAEE;EACE,wCAAA,EAAA,8BAAA;AACJ;;AAGE;EACE,kCAAA;AAAJ","sourcesContent":[".item-list-card {\r\n    --border-style: none;\r\n    --inner-border-width: 0px;\r\n    zoom: .75;\r\n  }\r\n\r\n  cdk-virtual-scroll-viewport {\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  ion-select::part(icon) {\r\n    display: none !important;\r\n   }\r\n\r\n   ion-checkbox {\r\n    --size: 32px;\r\n   }\r\n\r\n  ion-content{\r\n    --ion-background-color: white !important;  /* Change la couleur de fond */\r\n\r\n  }\r\n\r\n  .checkbox-wrapper{\r\n    justify-content: center !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
